module.exports = __webpack_public_path__ + "static/media/Icon_Scroll.036f42c7.svg";